// extracted by mini-css-extract-plugin
export var pageDescription__main = "index-module--pageDescription__main--CwB99";
export var pageDescription__text = "index-module--pageDescription__text--ZvP3c";
export var pageDescription__video = "index-module--pageDescription__video--JyESg";